import template from './teamCalendar.html';
import controller from './teamCalendar.controller';
import './teamCalendar.scss';

let teamCalendarComponent = {
  restrict: 'E',
  bindings: {
    isWageInProcess: '<'
  },
  template,
  controller
};

export default teamCalendarComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamCalendar/teamCalendar.component.js